var msnObj = {
  createMsn: function () {
    //获取需要处理的容器
    this.gridAll = document.querySelector('.content-all');
    this.gridProgram = document.querySelector('.content-program');
    this.gridTank = document.querySelector('.content-tank');
    this.gridActivity = document.querySelector('.content-activity');
    this.gridMedia = document.querySelector('.content-media');
    this.gridProduct = document.querySelector('.content-product');

    //瀑布流配置
    var masOption = {
      itemSelector: 'none', // select none at first
      // percentPosition: true,
      stagger: 30, //错开
      transitionDuration: 0 //动画时间
      // columnWidth: '.grid__col-sizer',//元素宽度
      // gutter: '.grid__gutter-sizer', //间距宽度
      // nicer reveal transition
      // visibleStyle: {transform: 'translateY(0)', opacity: 1},
      // hiddenStyle: {transform: 'translateY(100px)', opacity: 0},
    };

    //创建瀑布流 如果没有数据就不创建
    if(window.cateData.isHaveData.all){
      this.msnryArr = new Masonry(this.gridAll, masOption);
      this.loadPage(this.gridAll, this.msnryArr);
    }
    if(window.cateData.isHaveData.program){
      this.msnryProgram = new Masonry(this.gridProgram, masOption);
      this.loadPage(this.gridProgram, this.msnryProgram);
    }
    if(window.cateData.isHaveData.tank){
      this.msnryTank = new Masonry(this.gridTank, masOption);
      this.loadPage(this.gridTank, this.msnryTank);
    }
    if(window.cateData.isHaveData.activity){
      this.msnryActivity = new Masonry(this.gridActivity, masOption);
      this.loadPage(this.gridActivity, this.msnryActivity);
    }
    if(window.cateData.isHaveData.media) {
      this.msnryMedia = new Masonry(this.gridMedia, masOption);
      this.loadPage(this.gridMedia, this.msnryMedia);
    }
    if(window.cateData.isHaveData.product) {
      this.msnryProduct = new Masonry(this.gridProduct, masOption);
      this.loadPage(this.gridProduct, this.msnryProduct);
    }
  },

  //进入页面重载布局
  loadPage: function (grid, msnry) {
    // 图片载入完成后再加载瀑布流样式
    imagesLoaded(grid, function () {
      msnry.options.itemSelector = '.content-item';
      var items = grid.querySelectorAll('.content-item');
      msnry.appended(items);

      $('.page-home').show();
      msnry.layout();
      $('.load').hide();

      if(!window.cateData.firstLoad){
        window.cateData.firstLoad = true;
      }
    });
  },

  //初始化无限滚动 瀑布流容器class sol行业 type 分类
  initInfScroll: function (grid, msnry, type) {
    var _this = this;
    if (window.cateData.msItemCount[window.cateData.pageTab] < window.cateData.pageItemNum) {
      return;
    }
    //初始化无限滚动
    window.cateData.infScroll = new InfiniteScroll(grid, {
      path: function () {
        // 如果上一次接口中的数据不足8条则不再加载 当正在加载的时候不请求下一次的数据
        if (window.cateData.msItemCount[window.cateData.pageTab] >= window.cateData.pageItemNum) {
            //baseUrl/栏目/子栏目(可选)/条件/wap/分页
          //根据模块切换接口地址
          if (window.cateData.pageModule == 'videos'){
            return '/api/video/get_more' + (window.location.search ? (window.location.search + '&') : '?') + 'page=' + window.cateData.pageTabIndex[window.cateData.pageTab];
          }else if(window.cateData.pageModule === 'collectVideos' || window.cateData.pageModule === 'authorVideos'){
            // 作者主页短视频、 个人中心短视频分页接口
            return window.location.origin + window.location.pathname + '?return=api&page=' +  window.cateData.pageTabIndex[window.cateData.pageTab];
          }else if(window.cateData.pageModule === 'industry'){
            return window.cateData.getContentUrl + window.cateData.pageIndustryType +'/' + type + '/wap/' + window.cateData.pageTabIndex[window.cateData.pageTab] + '?uid=' + window.cateData.userInfo.memberId;
          }else{
            return window.cateData.api.getItem +  window.cateData.api.getItemCondition +'/' +  window.cateData.device +'/' + window.cateData.pageTabIndex[window.cateData.pageTab] + '?uid=' + window.cateData.userInfo.memberId;
          }
        }
      },
      checkLastPage: true,
      // scrollThreshold: false,
      responseType: 'text',
      outlayer: msnry,
      // status: '.loading-box', //加载状态
      history: false,//写入浏览器历史记录
    });

    var proxyElem = document.createElement('div');

    //监听
    window.cateData.infScroll.on('load', function (response) {
      //处理数据中禁止再次加载
      // window.cateData.infScroll.scrollThreshold = false;
      window.cateData.infScroll.canLoad = false;



      var data = JSON.parse(response);
      if (window.cateData.pageModule == 'videos'){
        data = data.content;
      }else if(window.cateData.pageModule === 'collectVideos' || window.cateData.pageModule === 'authorVideos'){
        data.content = data.data;
        data.count = data.data.length;
      }
      //设置本次获取的数据条数
      window.cateData.msItemCount[window.cateData.pageTab] = data.count;
      //如果本次获取的数据小于8 则为最后一页 设置变量
      if(data.count < window.cateData.pageItemNum){
        window.cateData.pageTabIsLoadEnd[window.cateData.pageTab] = true;
      }
      //页面索引加1
      window.cateData.pageTabIndex[window.cateData.pageTab] += 1;

      var itemsHTML = data.content.map(_this.getItemHTML).join('');
      proxyElem.innerHTML = itemsHTML;
      var items = proxyElem.querySelectorAll('.content-item');

      //这里把实例赋给一个变量，避免切换tab后数据插入错误
      var infScrollObj = window.cateData.infScroll;
      imagesLoaded(items, function () {

        infScrollObj.appendItems(items);
        msnry.appended(items);

        //数据处理完毕，打开滚动加载
        // window.cateData.infScroll.scrollThreshold = true;
        window.cateData.infScroll.canLoad = true;

        //设置直播图标
        setLiveIcon();

        //再初始化一下标签事件，要不新增的标签不能点击 是跳链接不是切tab注释掉
        // pageTab.init();
        stopRurnLik();

        if (window.cateData.msItemCount[window.cateData.pageTab] < window.cateData.pageItemNum) {
          //将loader设置为加载完成
          msLoader.setEnd(window.cateData.pageTab);

          //如果没有下一页就销毁
          window.cateData.infScroll.destroy();
        } else {
          msLoader.setLoad(window.cateData.pageTab);
        }
      });

      try {
        // afterLoad 下一页数据加载完成执行
        window.cateData.infScroll.afterLoadMore();
      }catch (e) {
        console.log(e);
      }
    });

    //如果load出错
    window.cateData.infScroll.on('error', function () {
      // msLoader.setEnd();
    });

    //触发滚动
    window.cateData.infScroll.on( 'scrollThreshold', function() {
      // msLoader.setShow();
    });
    //发出请求时触发
    window.cateData.infScroll.on( 'request', function( path ) {
    });

    // load initial page
    // infScroll.loadNextPage();
  },

  //切换tab后需要重载定位样式
  layout: function (cate) {
    //销毁infScroll
    if(window.cateData.infScroll){
      window.cateData.infScroll.destroy();
    }

    if (cate === 'all'  && window.cateData.isHaveData[cate]) {
      this.msnryArr.layout();
      this.initInfScroll(this.gridAll, this.msnryArr, 'all');
    }
    if (cate === 'program' && window.cateData.isHaveData[cate]) {
      this.msnryProgram.layout();
      this.initInfScroll(this.gridProgram, this.msnryProgram, 'solution');
    }
    if (cate === 'tank' && window.cateData.isHaveData[cate]) {
      this.msnryTank.layout();
      this.initInfScroll(this.gridTank, this.msnryTank, 'case');
    }
    if (cate === 'activity' && window.cateData.isHaveData[cate]) {
      this.msnryActivity.layout();
      this.initInfScroll(this.gridActivity, this.msnryActivity, 'market');
    }
    if (cate === 'media' && window.cateData.isHaveData[cate]) {
      this.msnryMedia.layout();
      this.initInfScroll(this.gridMedia, this.msnryMedia, 'media');
    }
    if (cate === 'product' && window.cateData.isHaveData[cate]) {
      this.msnryProduct.layout();
      this.initInfScroll(this.gridProduct, this.msnryProduct, 'product');
    }

    //如果没有数据隐藏loading
    if(!window.cateData.isHaveData[cate]){
      msLoader.setHide();
    }else{
      msLoader.setShow();
    }

    //如果已经加载完成则loader显示加载完成提示 或 当前一页的数据小于设定数据
    if(window.cateData.pageTabIsLoadEnd[window.cateData.pageTab] || window.cateData.msItemCount[window.cateData.pageTab] < window.cateData.pageItemNum){
      msLoader.setEnd();
    }
  },

  //获取模板
  getItemHTML:function(photo){
    var itemTemplateSrc = document.querySelector('#photo-item-template').innerHTML;
    return msnObj.microTemplate(itemTemplateSrc, photo);
  },

  //渲染模板
  microTemplate:function(src, data){


    //是否是广告
    if (data.ad === 1) {
      data.showcontent = 'hide';

      //如果没有广告图片则隐藏此item
      if(data.coverurl === ''){
          return;
      }
    }else{
      data.showcontent = '';
    }

    //添加广告专用图片样式
    if (data.ad === 1) {
      data.adstyle = 'img-box-ad';
    }else{
      data.adstyle = '';
    }

    //是否有描述 行业频道模块的市场活动显示其他分类不显示， 案例智库 解决方案模块中显示
    if (data.summary && (data.type === 'activity' || window.cateData.pageIndustryType === 'tank' || window.cateData.pageIndustryType === 'program' || data.type === 'product' || data.type === 'filelist' || data.type === 'evaluation')) {
      data.showdesc = '';
    }else{
      data.showdesc = 'hide';
    }

    //是否有链接
    if (!data.url) {
      data.itemurl = 'javascript:void(0);';
    }else{
      data.itemurl = data.url;
    }

    //第二标题
    if (!data.secondTitle) {
      data.secondTitleShow = 'hide';
    }else{
      data.secondTitleShow = '';
    }

    //是否有typeUrl
    if (!data.typeUrl) {
      data.itemTypeUrl = 'javascript:void(0);';
    }else{
      data.itemTypeUrl = data.typeUrl;
    }

    // 文章标签
    if(data.tags){
      data.showTags = '';
      data.tagHtml = '';
      for(var i=0; i<data.tags.length;i++){
        data.tagHtml += '<span class="tag-item"><a href="'+ data.tags[i].url +'">' + data.tags[i].tName + '</a></span>'
      }


    }else{
      data.showTags = 'hide'
    }

    //市场活动状态
    if(data.status){
      switch (data.status) {
        case 0:
          data.metlabel = 'hide';
          data.metStatus = '';
          break;
        case 1:
          data.metlabel = 'met-label-reg';
          data.metStatus = '';
          break;
        case 2:
          data.metlabel = 'met-label-processing';
          data.metStatus = 'content-item-processing';
          break;
        case 3:
          data.metlabel = 'met-label-over';
          data.metStatus = 'content-item-over';
          break;
      }
    }else{
      data.metlabel = 'hide';
      data.metStatus = '';
    }

    //资料中心视频
    if(data.fileType === 'video'){
      data.metStatus = 'content-item-over';
    }

    //资料中心文件
    if(data.fileType === 'file'){
        data.showFiledown = '';
    }else{
        data.showFiledown = 'hide';
    }

    //产品显示new  图标
    if (data.slogan && data.slogan == 'new'){
      data.showProdNewTag = 'product-pic-new-tag';
    }

    //点赞状态
    if(data.collect === 0){
      data.collectType = 'false';
    }else{
      data.collectType = 'true';
    }

    //是否显示作者
    if(data.type === 'product'){
      data.showAuthor = 'hide';
      data.showLike = 'hide';
      data.showPriceBox = '';
    }else{
      data.showAuthor = '';
      data.showLike = '';
      data.showPriceBox = 'hide';
    }

    //产品图片适配
    if(data.type === 'product'){
      data.imgItemWraProd = 'imgItemWraProd';
    }else{
      data.imgItemWraProd = '';
    }

    //video封面图片适配
    if(data.type === 'videos'){
      if(data.showStyle == 0) {
        //横板封面图隐藏
        data.showStyleImgH = 'hide';
        data.showStyleImgS = '';
      } else{
        data.showStyleImgH = '';
        data.showStyleImgS = 'hide';
      }
    }

    //是否显示时间
    if(data.type === 'product' || data.status === '2'){
      data.showtime = 'hide';
    }else{
      data.showtime = '';
    }

    //是否显示参考价格
    if(data.type === 'product' && data.price !== ''){
      data.showPrice = '';
    }else{
      data.showPrice = 'hide';
    }

    if(data.type === 'product' && data.price === ''){
      data.showContact = '';
    }else{
      data.showContact = 'hide';
    }

    //是否显示作者收藏栏
    if(data.type === 'activity'){
      data.showAuthorRow = 'hide';
    }else{
      data.showAuthorRow = '';
    }

    //是否显示vipIcon
    if(data.author_vip === 1){
      data.showVipIcon ='';
    }else{
      data.showVipIcon = 'hide';
    }

    //设置作者链接
    if(data.author_id){
      data.authorUrl = window.rootUrl + '/author/' + data.author_id;
    }

    //是否显示资料中心文件大小
    if(data.type === 'filelist' && data.fileType === 'file'){
      data.showFileSize = '';
      data.showAuthor = 'hide';
    }else{
      data.showFileSize = 'hide';
    }

    //是否显示视频弹窗点击层
    if(data.type === 'filelist' && data.fileType === 'video'){
      data.showVideoAct = '';
    }else{
      data.showVideoAct = 'hide';
    }

    //判断栏目添加随机高度(解决方案、案例智库、媒体文章)
    if((window.cateData.pageTab === 'program' || window.cateData.pageTab === 'tank' || window.cateData.pageTab === 'media' || window.cateData.pageTab === 'evaluation') && data.ad === 0){
      if(data.randStyle === 1){
        data.randstyle = 'item-height-h';
      }else{
        data.randstyle = 'item-height-l';
      }
    }else if(data.ad === 1){
      data.randstyle = '';
    }else{
      data.randstyle = 'item-height-l';
    }

    //判断 短视频 置顶图标（只有热门tab有）
    if(data.isTop === 1 && window.cateData.videoPage === 'hot'){
        data.showIsTop = '';
    }else{
        data.showIsTop = 'hide';
    }

    //判断是否置顶
    if(data.recommand === 1){
      data.showRecommand = '';
    }else{
      data.showRecommand = 'hide';
    }

    //如果是智库和解决方案模块则不显示类型标签和发布时间
      if(window.cateData.pageIndustryType === 'tank' || window.cateData.pageIndustryType === 'program' || window.cateData.pageModule === 'filelist' || window.cateData.pageModule === 'evaluation'){
          data.showTypeRow = 'hide';
      }else{
          data.showTypeRow = '';
      }


    //没有图片，替换默认图片
    if (!data.coverurl) {
      if(data.status === '2'){
        data.coverurl = '/static/mobile/images/defaultimg-zbz.jpg';
      }else{
        data.coverurl = '/static/mobile/images/defaultimg.jpg';
      }
    }

    // 替换{{}}标签资源
    return src.replace(/\{\{([\w\-_\.]+)\}\}/gi, function (match, key) {
      var value = data;
      key.split('.').forEach(function (part) {
        value = value[part];
      });
      return value;
    });
  }
};

//控制loading
var msLoader = {
  setEnd: function (type) {
    setTimeout(function () {
      $('.loading-infinite').hide();
      $('.loading-end').show();
    }, 1000);
  },
  setLoad: function (type) {
    $('.loading-infinite').show();
    $('.loading-end').hide();
  },
  setHide: function(){
    $('.loading-box').hide();
  },
  setShow: function(){
    $('.loading-box').show();
    this.setLoad();
  }
};



//浏览器窗口变化后重新渲染样式
// window.addEventListener("resize", function () {
//   msnObj.layout(window.cateData.pageTab);
// }, true);

window.onorientationchange=function(){
  if(window.orientation==90||window.orientation==-90){
    // alert('竖屏观看效果最佳');
  }else{
    // alert( new Date());
  }
}

